import { Skeleton } from "antd";
import React from "react";

export const LoadingSkeleton: React.FC<{
  count: number;
  loading: boolean;
  active?: boolean;
}> = ({ count, loading, active = true }) => {
  if (!loading) {
    return null;
  }

  return (
    <div>
      {Array.from({ length: count }, (_, i) => {
        return <Skeleton loading={loading} active={active} key={i} />;
      })}
    </div>
  );
};
